const TicketType = {
  GET_TICKETS: 'GET_TICKETS',
  GET_TICKET: 'GET_TICKET',
  CREATE_TICKET: 'CREATE_TICKET',
  CREATE_TICKET: 'UPDATE_TICKET',
  UPLOAD_FILE: 'UPLOAD_FILE',
  UPDATE_TICKET_LEVEL: 'UPDATE_TICKET_LEVEL',
}

export default TicketType
